require("./src/styles/index.scss")

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

exports.onInitialClientRender = () => {
  window.addEventListener("scroll", handleScroll)
  function handleScroll() {
    const nav = document.getElementById("header")
    if (window.scrollY > 0) {
      nav.classList.remove("top")
    } else {
      nav.classList.add("top")
    }
  }
}

// You can delete this file if you're not using it
